//
//
//
//
//
//
//
//
//
//

import { TokenButton } from '@/components/token-button'
export default {
  name: 'App',
  data () {
    return {
      isRouterAlive: true,
      showTokenButton: process.env.NODE_ENV === 'development'
    }
  },
  components: {
    TokenButton
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue